import normalizeLocale from "../i18n/normalizeLocale";

export function changeDOMLangAttribute(language) {
  const locale = normalizeLocale(language);
  const lang = locale.split("-")[0];

  document.documentElement.setAttribute("lang", lang);
}
